import * as http from "./http";
export const getUrlParam = (name) => {
  return new URLSearchParams(location.search).get(name);
};
export const getMobileEnv = () => {
  const u = navigator.userAgent;
  return {
    mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
    ios: !!u.match(/iPhone|iPod|iPad/i), //ios终端
    android: !!u.match(/Android/i), //android终端,
    wechat: !!(u.toLowerCase().match(/MicroMessenger/i) == "micromessenger"), //微信终端
    wechatMobile:
      !!(u.toLowerCase().match(/MicroMessenger/i) == "micromessenger") &&
      (u.indexOf("Android") > -1 ||
        u.indexOf("iPhone") > -1 ||
        u.indexOf("iPad") > -1), //微信终端
  };
};
export const checkWxMini = () => {
  return new Promise((resolve) => {
    if (!getMobileEnv().wechatMobile) {
      sessionStorage.setItem("isWxMini", "");
      resolve(false);
    } else {
      parent.wx.miniProgram.getEnv((res) => {
        if (res.miniprogram) {
          sessionStorage.setItem("isWxMini", 1);
          resolve(true);
        } else {
          sessionStorage.setItem("isWxMini", "");
          resolve(false);
        }
      });
    }
  });
};
export const checkWxBrowser = () => {
  return new Promise((resolve) => {
    checkWxMini().then(() => {
      setTimeout(() => {
        resolve(
          !sessionStorage.getItem("isWxMini") && getMobileEnv().wechatMobile
        );
      }, 0);
    });
  });
};
export const checkUrlUpdate = () => {
  if (!getUrlParam("timestamp")) {
    location.replace(
      `${location.href}${
        location.href.includes("?") ? "&" : "?"
      }timestamp=${new Date().getTime()}`
    );
  }
};
export const initConfig = (url) => {
  return new Promise((resolve) => {
    http
      .post("https://test.333f.com/data-center/wechat/sign", {
        appid: "wxbc5b737d6921c2dd",
        localUrl: url || location.href,
      })
      .then((res) => {
        const { appId, nonceStr, signature, timestamp } = res.data;
        parent.wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId, // 必填，公众号的唯一标识
          timestamp, // 必填，生成签名的时间戳
          nonceStr, // 必填，生成签名的随机串
          signature, // 必填，签名
          jsApiList: [
            "updateAppMessageShareData",
            "updateTimelineShareData",
            "wx-open-launch-weapp",
            "wx-open-subscribe",
            "chooseImage",
          ], // 必填，需要使用的JS接口列表,
          openTagList: ["wx-open-launch-weapp"],
          fail(err) {
            console.log("setShareConfig err", err);
          },
        });
        parent.wx.ready(function () {
          // window.alert('微信调用成功')
          wxShare();
          resolve(true);
        });
      })
      .catch((err) => {
        console.error(err);
        resolve(false);
      });
  });
};
export const wxLaunch = (info) => {
  const btn = document.createElement("div"); //获取元素
  btn.style =
    "position:fixed;top:0;left:0;right:0;bottom:0;z-index:99;background: rgba(0,7,19, 0.8);";
  const script = document.createElement("script"); // 创建script内容插槽 避免template标签冲突
  script.type = "text/wxtag-template"; // 使用script插槽 必须定义这个type
  script.text = info.content; // 自定义的html字符串内容
  const html = `<div style="z-index:999;position:absolute;top:50%;left:50%;transform:translateX(-50%) translateY(-50%);display:flex;justify-content:center;align-items:center;width:300px;height:48px;">
                  <wx-open-launch-weapp id="wx-launch-btn" style="z-index:9999;position:absolute;top:0;left:0;right:0;bottom:0;" username="${info.appId}" path="${info.url}">${script.outerHTML}</wx-open-launch-weapp>
                </div>`;
  btn.innerHTML = html; // html字符串赋值
  document.body.appendChild(btn);
  setTimeout(() => {
    const dom = document.getElementById("wx-launch-btn");
    dom.addEventListener("launch", function (e) {
      console.log("launch", e);
    });
    // 点击跳转 抛出异常
    dom.addEventListener("error", function (e) {
      console.log("fail", e.detail);
      alert(`跳转异常 - ${e.detail}`);
    });
  }, 600);
};
export const wxLocate = async () => {
  const checkWxBrowserResult = await checkWxBrowser();
  if (checkWxBrowserResult) {
    checkUrlUpdate();
  }
  const initResult = await initConfig();
  if (initResult && checkWxBrowserResult) {
    // if (checkWxBrowserResult) {
    wxLaunch({
      appId: "gh_6853edaf1b86",
      url: `pages/externalLinkLandscape/index?url=${encodeURIComponent(
        location.href
      )}`, // process.env.VITE_APP_MINIPROGRAM_URL,
      content: `<div style="z-index:99999;position:absolute;top:0;left:0;right:0;bottom:0;display:flex;justify-content:center;align-items:center;background:#07c160;padding:10px;20px;border-radius:50px;">
        <span style="font-size:16px;font-family:PingFang SC-Medium, PingFang SC;font-weight:500;color:#ffffff;">检测到微信环境，点击此处体验更佳！</span>
        </div>`,
    });
  }
};

/**
 * 微信分享注入
 */
export const wxShare = (option = {}) => {
  !option && (option = {});
  option.link = option.url || location.href;
  const { title, link, desc, imgUrl } = option;
  // console.log(option, "wxShare");
  const shareParam = {
    title: title,
    link: link,
    desc: desc,
    imgUrl: imgUrl,
  };
  parent.wx.updateTimelineShareData({
    ...shareParam,
    success() {
      console.log("updateTimelineShareData success");
    },
    fail(err) {
      console.log(err, "updateTimelineShareData");
    },
  });
  parent.wx.updateAppMessageShareData({
    ...shareParam,
    success() {
      console.log("updateAppMessageShareData success");
    },
    fail(err) {
      console.log(err, "updateAppMessageShareData");
    },
  });
  parent.wx.miniProgram.getEnv((res) => {
    if (res.miniprogram) {
      parent.wx.miniProgram.postMessage({
        data: {
          url: shareParam.link,
          title: shareParam.title,
          img: shareParam.imgUrl,
        },
      });
    }
  });
};
